import { ReactNode } from 'react';
import styled from 'styled-components';
import { defaultColors } from '../../styles/style-guide';
import { RootState } from '../../store';
import { useAppSelector } from '../../hooks/hooksRedux';

interface Props extends React.InputHTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
}

const TexTitle = styled.h4<{ $color?: string }>`
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
  color: ${({ $color }) => $color || defaultColors.primary};
`;

const SpanSubTitleStyle = styled.span<{ $color?: string }>`
  margin-top: -4px;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 700;
  color: ${({ $color }) => $color || defaultColors.other};
`;

const TextTitle = ({ children, ...rest }: Props) => {
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColor = colors.primary || defaultColors.primary;
  return (
    <TexTitle {...rest} $color={primaryColor}>
      {children}
    </TexTitle>
  );
};

const SpanSubTitle = ({ children, ...rest }: Props) => {
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const primaryColor = colors.primary || defaultColors.primary;

  return (
    <SpanSubTitleStyle {...rest} $color={primaryColor}>
      {children}
    </SpanSubTitleStyle>
  );
};

export { TextTitle, SpanSubTitle };
